module.exports = __webpack_public_path__ + "static/media/Footer-top-border.e50467e0.svg";